/**
 * Handles scrolling from Lipscore rating widget to reviews section
 * Waits for the lipscore-rating-small element to be rendered by the app block
 */
(function() {
  'use strict';

  const REVIEWS_SECTION_ID = 'lipscore-review-list';
  const RATING_SELECTOR = '.lipscore-rating-small';

  /**
   * Scrolls smoothly to the reviews section
   */
  function scrollToReviews() {
    const reviewsSection = document.getElementById(REVIEWS_SECTION_ID);
    if (!reviewsSection) {
      console.warn(`Reviews section with ID "${REVIEWS_SECTION_ID}" not found`);
      return;
    }

    // Calculate offset to account for sticky header if needed
    const header = document.querySelector('header, .header');
    const headerHeight = header ? header.offsetHeight : 0;
    const offset = 20; // Additional offset for spacing

    const targetPosition = reviewsSection.getBoundingClientRect().top + window.scrollY - headerHeight - offset;

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
  }

  /**
   * Attaches click handlers to all lipscore-rating-small elements
   */
  function attachClickHandlers() {
    const ratingElements = document.querySelectorAll(RATING_SELECTOR);
    
    ratingElements.forEach(element => {
      // Skip if already has handler attached
      if (element.dataset.scrollHandlerAttached === 'true') {
        return;
      }

      // Make element clickable if it isn't already
      if (!element.style.cursor) {
        element.style.cursor = 'pointer';
      }

      element.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        scrollToReviews();
      });

      // Mark as handled
      element.dataset.scrollHandlerAttached = 'true';
    });
  }

  /**
   * Initialize using MutationObserver to watch for dynamically added elements
   */
  function init() {
    // Check if elements already exist
    attachClickHandlers();

    // Watch for new elements being added to the DOM
    const observer = new MutationObserver(function(mutations) {
      let shouldCheck = false;
      
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
          // Check if any added node contains or is a lipscore-rating-small element
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              if (node.matches && node.matches(RATING_SELECTOR)) {
                shouldCheck = true;
              } else if (node.querySelector && node.querySelector(RATING_SELECTOR)) {
                shouldCheck = true;
              }
            }
          });
        }
      });

      if (shouldCheck) {
        attachClickHandlers();
      }
    });

    // Start observing the document body for changes
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Also check periodically as a fallback (in case MutationObserver misses something)
    // This is especially useful for app blocks that might render in iframes or shadow DOM
    let checkInterval = setInterval(function() {
      const ratingElements = document.querySelectorAll(RATING_SELECTOR);
      if (ratingElements.length > 0) {
        attachClickHandlers();
        // Clear interval after finding elements to avoid unnecessary checks
        clearInterval(checkInterval);
      }
    }, 500);

    // Stop checking after 10 seconds to avoid infinite polling
    setTimeout(function() {
      clearInterval(checkInterval);
    }, 10000);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    // DOM is already ready
    init();
  }
})();

